<template>
  <div id="page">
    <NavBarHome :show-coming-soon="showComingSoon" />

    <main class="pattern">
      <!--  SEARCH  -->
      <section class="hero_single version_5">
        <div class="wrapper">
          <div
            class="container"
            style="margin-top: 3rem;"
          >
            <div class="row justify-content-center pt-lg-5">
              <div class="col-xl-5 col-lg-6 search-right-margin">
                <h3 class="home_title mb-2">
                  {{ $t('lang.search.title') }}
                  <img
                    class="d-inline-flex d-md-none"
                    src="../assets/img/maleta.png"
                    width="25"
                  >
                </h3>
                <h1 class="home_subtitle">
                  {{ $t('lang.search.text') }}
                </h1>

                <div
                  v-if="showComingSoon"
                  class="custom-search-input-2"
                >
                  <ComingSoon />
                </div>

                <div
                  v-else
                  class="custom-search-input-2"
                >
                  <SearchForm :set-location="searchPlace" />
                </div>
              </div>
              <div class="col-xl-5 col-lg-6 text-right d-none d-lg-block illustration-left-margin">
                <img
                  src="../assets/img/illustrations/Travelers-home.png"
                  alt="Viajeros WeKeep"
                  title="Viajeros recorriendo cargando valijas"
                  class="img-fluid"
                >
              </div>
            </div>
          </div>
          <ScrollableBenefits />
        </div>
      </section>

      <!--  HOW IT WORKS  -->
      <div
        id="how"
        class="how_works_section"
      >
        <div class="wrapper">
          <div class="container margin_80_55">
            <div class="main_title_2">
              <span><em /></span>
              <h2>{{ $t('lang.home.how_works.how_works_title') }}</h2>
              <h3>{{ $t('lang.home.how_works.how_works_subtitle') }}</h3>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <HowWorksCarousel />
              </div>
            </div>
          </div>
        </div>
        <!-- /wrapper -->
      </div>

      <!-- CIUDADES PRINCIPALES -->
      <div class="call_section popular_categories">
        <div class="container margin_80_55">
          <div class="main_title_2">
            <span><em /></span>
            <h2>{{ $t('lang.home.cities.title') }}</h2>
            <h3 class="mb-2">
              {{ $t('lang.home.cities.subtitle') }}
              <br>
              <span
                v-for="(country) in countriesList"
                :key="country.id"
                style="display: inline; background-color: transparent"
              >
                {{ country.icon }}
              </span>
            </h3>
          </div>
          <div class="row">
            <div class="col-lg-12 text-right mb-2">
              <b-link
                v-scroll-to="{el: '#footer_cities_list', offset: -140}"
                data-toggle="collapse"
                data-target="#collapse_ft_2"
                class="text-white"
              >
                {{ $t('lang.home.cities.see_all') }}
                <i class=" icon-right-small" />
              </b-link>
            </div>
            <div class="col-lg-12">
              <CitiesCarousel @selectedCity="setSearchPlace" />
            </div>
          </div>
          <!-- /row -->
        </div>
        <!-- /container -->
      </div>

      <!--  PRICING LIST -->
      <Prices />

      <!-- REVIEWS PRINCIPALES -->
      <div class="call_section">
        <div class="container margin_80_55">
          <div class="main_title_2">
            <span><em /></span>
            <h2>{{ $t('lang.home.reviews_title') }}</h2>
            <h3>{{ $t('lang.home.reviews_subtitle') }} 😍</h3>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <ReviewsCarousel />
            </div>
          </div>
          <!-- /row -->
        </div>
        <!-- /container -->
      </div>

      <!--  APP AVAILABLE  -->
      <div
        v-if="!$store.state.main.app"
        class="app_section"
      >
        <div class="container margin_80_55">
          <div class="main_title_2">
            <span><em /></span>
            <h2>{{ $t('lang.home.app.title') }}</h2>
            <h3>{{ $t('lang.home.app.subtitle') }}</h3>
          </div>
          <div class="row justify-content-center align-items-center text-center">
            <img
              src="../assets/img/app/app_home.png"
              alt="app"
              class="mb-1"
              height="350"
              width="auto"
            >
            <div class="app_icons d-flex flex-column align-items-end">
              <a
                href="https://play.google.com/store/apps/details?id=app.wekeep.wekeep"
                target="_blank"
                class="mb-4"
              >
                <img
                  src="../assets/img/app/app_android.png"
                  alt="Android WeKeep App"
                  title="Android WeKeep App"
                  width="150"
                  height="48"
                >
              </a>
              <a
                href="https://apps.apple.com/us/app/wekeep/id1553561341"
                target="_blank"
              >
                <img
                  src="../assets/img/app/app_apple.png"
                  alt="iOS WeKeep App"
                  title="iOS WeKeep App"
                  width="150"
                  height="50"
                >
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- STORES APP  -->
      <StoresSite v-if="!$store.state.main.app" />
    </main>
    <FooterComponent @selectedCity="setSearchPlace" />
  </div>
</template>

<script>
import ComingSoon from '@/components/Home/ComingSoon';
import StoresSite from '@/components/Home/StoresSite';
import Prices from '@/components/Home/Prices';
import ReviewsCarousel from '@/components/Home/ReviewsCarousel';
import HowWorksCarousel from '@/components/Home/HowWorksCarousel';
import NavBarHome from '../components/NavBar/NavBarHome';
import SearchForm from '../components/Search/SearchForm';
import FooterComponent from '../components/FooterComponent';
import { cities } from '../data/cities';
import countries from '../data/countries';
import CitiesCarousel from '../components/Home/CitiesCarousel';
import ScrollableBenefits from '@/components/Home/ScrollableBenefits.vue';

export default {
  name: 'Home',
  components: {
    ScrollableBenefits,
    HowWorksCarousel,
    ReviewsCarousel,
    CitiesCarousel,
    SearchForm,
    NavBarHome,
    FooterComponent,
    ComingSoon,
    StoresSite,
    Prices,
  },

  data() {
    return {
      showComingSoon: false,
      launchOrLater: false,
      searchPlace: {},
      countriesList: countries,
    };
  },

  created() {
    this.launchOrLater = (new Date()) > (new Date('2021-03-01'));

    // if (this.$route.query.app || this.launchOrLater) {
    //   this.showComingSoon = false;
    // } else {
    //   this.showComingSoon = true;
    // }
  },

  methods: {

    setSearchPlace(city) {
      const cityData = cities.find((data) => data.id === city);
      const place = { geometry: cityData.geometry, formatted_address: this.$t(`lang.cities.${cityData.id}`) };
      this.searchPlace = place;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },

};
</script>
